<template>
  <Button
    color="text-primary"
    :title="$t('Report Management')"
    :icon-btn="true"
    :icon-with-background="true"
    small
    class="ma-1"
    @click="$emit('click')"
  >
    <v-icon size="small">
      mdi-file-upload
    </v-icon>
  </Button>
</template>

<script setup lang="ts">
import Button from "@/components/input-components/Button.vue";

defineOptions({ name: "OrderGridActionReportManagement" });

const emit = defineEmits(['click']);
</script>
